export class Step9 {
    constructor() {}

    intitule = 'stepper.form.mapa_in.step8';
    getspan16 = 'form.mapa_in.getspan16';
    gettypecrjugement = 'form.mapa_in.typecrjugement';
    getcriterecdc = 'form.mapa_in.getcriterecdc';
    getcriterepondere = 'form.mapa_in.getcriterepondere_liste_avi_';
    getcritere = 'form.mapa_in.getcritere';
    getcriterepct = 'form.mapa_in.getcriterepct';
    getcriterelibrevide = 'form.mapa_in.getcriterelibrevide';
    getcriterelibre = 'form.mapa_in.getcriterelibre';
    getcritereprix = 'form.mapa_in.getcritereprix';
    add = 'boutons.add';
    remove = 'boutons.remove';

}
